export default __webpack_public_path__ + "static/media/dreadarchmagebloodarcanist.08adb1a0.png";